import React from 'react';
import { usePermission } from '../hooks/usePermission';

interface Props {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const CanDo: React.FC<Props> = ({ permission, children, fallback = null }) => {
  const can = usePermission(permission);
  return can ? <>{children}</> : <>{fallback}</>;
};

export default CanDo;
